module.exports = __webpack_public_path__ + "media/images/components/map-icons/default-marker-disabled-fda41a100f485aebf0d5c9207877bc4c.png";